<template>
  <nav class="navbar" :class="{ 'navbar-scrolled': isScrolled }">
    <div class="nav-container">
      <router-link to="/" class="logo gradient-text">{{ companyName }}</router-link>
      <ul class="nav-menu">
        <li><router-link to="/" class="link-hover">Home</router-link></li>
        <li><router-link to="/equipment" class="link-hover">Equipment</router-link></li>
        <li><router-link to="/about" class="link-hover">About Us</router-link></li>
        <li><a href="#contact" class="link-hover">Contact</a></li>
      </ul>
      <div class="nav-search">
        <div class="search-container">
          <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input 
            type="text" 
            class="search-input" 
            placeholder="Search products, solutions..."
            v-model="searchQuery"
            @input="handleSearch"
            @focus="showDropdown = true"
            @blur="handleBlur"
          />
          <!-- 搜索建议下拉框 -->
          <div v-if="showDropdown && filteredProducts.length > 0" class="search-dropdown">
            <div class="search-header" v-if="!searchQuery">
              <h4>Popular Products</h4>
            </div>
            <div 
              v-for="product in filteredProducts" 
              :key="product.id" 
              class="search-item"
              @mousedown="selectProduct(product)"
            >
              <div class="search-item-image">
                <img :src="product.image" :alt="product.name">
              </div>
              <div class="search-item-info">
                <h4>{{ product.name }}</h4>
                <p>{{ product.category }}</p>
                <span class="search-item-price">${{ product.price.toLocaleString() }}</span>
              </div>
            </div>
            <div class="search-footer">
              <router-link to="/products" class="view-all-link">
                {{ searchQuery ? 'View all results' : 'Browse all products' }} →
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-actions">
        <button class="nav-btn btn-hover">Get in Touch</button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    companyName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isScrolled: false,
      searchQuery: '',
      showDropdown: false,
      products: [
        {
          id: 1,
          name: 'Permobil F5 Power Chair',
          category: 'Power Wheelchairs',
          price: 45000,
          image: 'https://via.placeholder.com/50x50?text=F5'
        },
        {
          id: 2,
          name: 'Memory Foam Cushion',
          category: 'Seating & Positioning',
          price: 2800,
          image: 'https://via.placeholder.com/50x50?text=Cushion'
        },
        {
          id: 3,
          name: 'Lightweight Manual Chair',
          category: 'Manual Wheelchairs',
          price: 8500,
          image: 'https://via.placeholder.com/50x50?text=Manual'
        },
        {
          id: 4,
          name: 'Safety Belt System',
          category: 'Accessories',
          price: 2200,
          image: 'https://via.placeholder.com/50x50?text=Belt'
        },
        {
          id: 5,
          name: 'Premium Gel Cushion',
          category: 'Seating & Positioning',
          price: 5500,
          image: 'https://via.placeholder.com/50x50?text=Gel'
        },
        {
          id: 6,
          name: 'Adjustable Footrest',
          category: 'Accessories',
          price: 1200,
          image: 'https://via.placeholder.com/50x50?text=Footrest'
        }
      ]
    }
  },
  computed: {
    filteredProducts() {
      if (!this.searchQuery) return [];
      
      const query = this.searchQuery.toLowerCase();
      return this.products.filter(product => {
        return (
          product.name.toLowerCase().includes(query) ||
          product.category.toLowerCase().includes(query)
        );
      }).slice(0, 5); // 最多显示5个结果
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    handleSearch() {
      // 实时搜索，不需要额外处理
      // 通过computed属性filteredProducts自动更新结果
    },
    handleBlur() {
      // 延迟关闭下拉框，以便能够点击结果
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
    selectProduct(product) {
      // 跳转到产品详情页
      this.$router.push(`/product/${product.id}`);
      this.searchQuery = '';
      this.showDropdown = false;
    }
  }
}
</script>

<style scoped>
.navbar {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(26, 35, 126, 0.1);
}

.navbar-scrolled {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 4px 30px rgba(0,0,0,0.15);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
  background: linear-gradient(45deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-decoration: none;
  margin-left: -5px; /* 微调为向左移动5px */
  padding-left: 5px; /* 相应调整内边距 */
}

.logo:hover {
  transform: scale(1.05);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2.5rem;
  margin: 0;
  padding: 0;
  margin-left: 2rem; /* 增加与logo的间距 */
}

.nav-menu a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.5rem 0;
}

.nav-menu a:hover {
  color: #1a237e;
}

.nav-search {
  flex: 1;
  max-width: 400px;
  margin: 0 2rem;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-radius: 24px;
  padding: 8px 16px;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.search-container:focus-within {
  background: #fff;
  border-color: #1a237e;
  box-shadow: 0 0 0 3px rgba(26, 35, 126, 0.1);
}

.search-icon {
  color: #6c757d;
  margin-right: 8px;
  flex-shrink: 0;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 0.9rem;
  color: #333;
  width: 100%;
}

.search-input::placeholder {
  color: #6c757d;
  font-size: 0.9rem;
}

/* 搜索下拉框样式 */
.search-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.search-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e9ecef;
  text-align: center;
}

.search-header h4 {
  margin: 0;
  font-size: 0.95rem;
  color: #6c757d;
}

.search-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.search-item:hover {
  background-color: #f8f9fa;
}

.search-item-image {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
}

.search-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.search-item-info {
  flex: 1;
}

.search-item-info h4 {
  margin: 0;
  font-size: 0.95rem;
  color: #333;
  margin-bottom: 4px;
}

.search-item-info p {
  margin: 0;
  font-size: 0.8rem;
  color: #6c757d;
  margin-bottom: 4px;
}

.search-item-price {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1a237e;
}

.search-footer {
  padding: 12px 16px;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.view-all-link {
  color: #1a237e;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.2s ease;
}

.view-all-link:hover {
  color: #0d47a1;
}

.nav-actions {
  display: flex;
  gap: 1rem;
}

.nav-btn {
  background: linear-gradient(135deg, #1a237e, #0d47a1);
  color: white;
  border: none;
  border-radius: 25px;
  padding: 0.8rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(26, 35, 126, 0.2);
}

.nav-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(26, 35, 126, 0.3);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .nav-search {
    max-width: 280px;
    margin: 0 1rem;
  }
}

@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }
  
  .nav-search {
    display: none;
  }
  
  .nav-container {
    padding: 1rem;
  }
  
  .logo {
    font-size: 1.6rem;
  }
  
  .nav-btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.9rem;
  }
}
</style>